export interface MenuItem {
  heading?: string;
  sectionTitle?: string;
  route?: string;
  capDonVi?: number[];
  perm?: string | string[];
  permAny?: string[];
  requireDonViForCap1?: boolean;
  readonlyForCap1?: boolean;
  hidden?: boolean;
  sub?: MenuItem[];
  [key: string]: unknown;
}

export interface MenuGroup {
  heading?: string;
  route?: string;
  pages: MenuItem[];
}

function itemVisible(item: MenuItem, capDonVi: number, permissions: Set<string>): boolean {
  if (item.hidden) {
    return false;
  }

  if (item.capDonVi && !item.capDonVi.includes(capDonVi)) {
    return false;
  }

  if (item.perm) {
    const perms = Array.isArray(item.perm) ? item.perm : [item.perm];
    if (!perms.every((p) => permissions.has(p))) return false;
  }

  if (item.permAny && item.permAny.length > 0) {
    if (!item.permAny.some((p) => permissions.has(p))) return false;
  }

  return true;
}

function filterItem(item: MenuItem, capDonVi: number, permissions: Set<string>): MenuItem | null {
  if (!itemVisible(item, capDonVi, permissions)) return null;

  if (item.sub && item.sub.length > 0) {
    const filteredSub = item.sub
      .map((child) => filterItem(child, capDonVi, permissions))
      .filter((child): child is MenuItem => child !== null);

    if (filteredSub.length === 0) return null;

    return { ...item, sub: filteredSub };
  }

  return item;
}

export function filterMenuByCapAndPerm(
  menu: MenuGroup[],
  { capDonVi, permissions }: { capDonVi: number; permissions: Set<string> }
): MenuGroup[] {
  return menu
    .map((group) => {
      const filteredPages = group.pages
        .map((page) => filterItem(page, capDonVi, permissions))
        .filter((page): page is MenuItem => page !== null);

      return { ...group, pages: filteredPages };
    })
    .filter((group) => group.pages.length > 0);
}
